import * as React from "react";
import { FieldWrapper, FieldWrapperPassThroughProps } from "./field-wrapper";
import { cn } from "../../../utils/cn";

type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> &
  FieldWrapperPassThroughProps & {
    className?: string;
  };

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, ...props }, ref) => {
    return (
      <FieldWrapper label={label} htmlFor={label}>
        <textarea
          ref={ref}
          className={cn("text-input with-border", className)}
          {...props}
        />
      </FieldWrapper>
    );
  },
);

Textarea.displayName = "Textarea";

export { Textarea };